/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Approval_AwaitingInputs */



/**
* | output |
* | --- |
* | "This run is waiting for an authorized approver." |
*
* @param {Agent_Run_Approval_AwaitingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_awaiting = /** @type {((inputs?: Agent_Run_Approval_AwaitingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_AwaitingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Lauf wartet auf eine berechtigte freigebende Person.")
	return /** @type {LocalizedString} */ ("This run is waiting for an authorized approver.")
});